import { Button, Chip, Typography, useTheme } from '@mui/material';
import { Box } from '@mui/material';
import React from 'react';
import PaymentsIcon from '@mui/icons-material/Payments';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import SentimentVerySatisfiedIcon from '@mui/icons-material/SentimentVerySatisfied';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { PlanTagWithName } from '../types';
import { Currencies, CURRENCY_SYMBOLS } from '../../../types';

interface Props {
    planId: number;
    quickOrderCosts: {materialsCost: string, materialsCostCurrency: Currencies}[];
    timeCost: string | null;
    ratingsSummary: string | null;
    isBuyNowEnabled: boolean;
    tags: PlanTagWithName[];
}

export const PlanPrimaryInfoSection = ({planId, quickOrderCosts, timeCost, ratingsSummary, isBuyNowEnabled, tags}: Props) => {
	const theme = useTheme();
	const {t} = useTranslation();
	const {materialsCost, materialsCostCurrency} = quickOrderCosts.length > 0 ? {materialsCost: quickOrderCosts[0].materialsCost, materialsCostCurrency: quickOrderCosts[0].materialsCostCurrency} : {materialsCost: null, materialsCostCurrency: null};
	const currencySymbol = materialsCostCurrency ? CURRENCY_SYMBOLS[materialsCostCurrency] : '';
	return <><Box display='flex' flexDirection='row' gap={2} sx={{mb: 2}} justifyContent='space-between'>
		<Box display='flex' flexDirection='row' gap={2}>
			{materialsCost && <Box display='flex' flexDirection='row' gap={1} alignItems='center'>
				<PaymentsIcon sx={{color: theme.palette.success.main}} />
				<Typography variant='body1' color='text.secondary'>{currencySymbol}{materialsCost}</Typography>
			</Box>}
			{timeCost && <Box display='flex' flexDirection='row' gap={1} alignItems='center'>
				<AccessTimeIcon />
				<Typography variant='body1' color='text.secondary'>{timeCost}</Typography>
			</Box>}
			{ratingsSummary && <Box display='flex' flexDirection='row' gap={1} alignItems='center'>
				<SentimentVerySatisfiedIcon />
				<Typography variant='body1' color='text.secondary'>{ratingsSummary}</Typography>
			</Box>}
		</Box>
		{isBuyNowEnabled && <Box>
			<Button component={Link} to={`/plans/${planId}/supplies`} variant='contained' color='primary' endIcon={<ShoppingCartIcon />}>
				{t('planView.buyNow')}
			</Button>
		</Box>}
	</Box>
	{Boolean(tags.length) && <Box display='flex' flexWrap='wrap' gap={1} sx={{mb: 2}}>
		{tags?.map((tag) => <Chip key={tag.tagName} label={t(`tags.${tag.tagName}`, {defaultValue: `${tag.tagName[0].toUpperCase()}${tag.tagName.slice(1)}`})} color={'default'} />)}
	</Box>}</>;
};